import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const Header = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false); 
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLoginClick = () => {
    if (isAuthenticated) {
      navigate('/sass',{replace:true});
    } else {
      navigate('/login');
    }
  };

  return (
    <header className='w-full py-4'>
      <div className='container flex items-center justify-between h-14 max-lg:px-5'>
        <a className='cursor-pointer' href="/">
          <img src="/images/walle.png" width={160} height={55} alt="logo" />
        </a>
        <button 
          onClick={handleLoginClick} 
          className='font-poppins font-bold text-white uppercase rounded-md px-5 py-3 shadow-lg bg-gradient-to-b from-blue-600 to-teal-600'>
          Login
        </button>
      </div>
    </header>
  );
}

export default Header;
